export enum LocalEvents {
    APPLICATION_NOTIFICATION_CHANGED = "application-notification:changed",
}
